import React, { Component } from "react";
import { Row, Col } from "antd";
import RmxImg from "../../assets/images/rmx-step.png";
import { connect } from "react-redux";
import { UserAction, AuthAction } from "../../store/actions";
import AccountImg from "../../assets/images/setting.png";
import UserIcon from "../../assets/images/TRKR-Login-Process-Icons-15.png";
import DriverIcon from "../../assets/images/TRKR-Login-Process-Icons-16.png";
import TruckIcon from "../../assets/images/con-truck.png";
import LineIcon from "../../assets/images/TRKR-Login-Process-Icons-17.png";
import WelcomeCard from "../../components/WelcomeCard";

class WelcomeContainer extends Component {
  componentDidMount() {
    const userId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[2]
      ?.rmx_company_user?.id;
    this.props.getUserDetail(userId);
  }
  render() {
    console.log("hhh=>", this.props.userDetails);
    return (
      <Row style={{ marginTop: "20px" }}>
        <Col
          xl={24}
          sm={24}
          xs={24}
          lg={24}
          md={24}
          style={{
            minHeight: "450px",
            background: "white",
            transform: "box-shadow .25s",
            boxShadow: "0px 0px 5px 0px rgb(0 0 0 / 16%)",
          }}
        >
          <Row style={{ padding: "1rem" }}>
            <Col xl={1}></Col>
            <Col
              xl={16}
              lg={12}
              xs={24}
              md={24}
              style={{
                marginTop: "25px",
              }}
            >
              <h4
                className="text-left welcome-font-family"
                style={{
                  fontSize: "20px",
                }}
              >
                Welcome to
                <span style={{ paddingLeft: "10px" }}>
                  {`${this.props?.userDetails?.first_name} ${this.props?.userDetails?.last_name}`}
                </span>
              </h4>
              <p
                className="text-left welcome-font-family"
                style={{
                  marginTop: "5px",
                }}
              >
                Follow the steps below to get started using TRKR and experience
                the ease of collaboration. This is how it works:
              </p>
              <p className="text-left welcome-font-family">
                Plant will approve an order and then dispatch. Once dispatched
                Logistics will recognize and assign a driver. At that point,
                there will be an email sent to the driver with a download link
                for the Demo TRKR MOBILE App. From the driver's phone they will
                be able to progress the order - pick-up, drop off, and complete.
                Included will be unlimited ability to capture media at all three
                stages. There is a safety checklist protocol included in all
                stages. And once completed the ability to share a Daily Report
                is also included.
              </p>
              <p className="text-left">
                To schedule a personalized demonstration of all the features of
                this innovative platform, please contact:
              </p>
              <Row>
                <Col
                  xl={8}
                  lg={10}
                  xs={24}
                  md={24}
                  className="green-sec text-left"
                >
                  <span className="d-block">MAIN FRAME</span>
                  <span className="d-block">+1 619 880 0265</span>
                  <span className="d-block">demo@main-frame.com</span>
                </Col>
              </Row>
            </Col>
            <Col xl={1}></Col>
            <Row justify="end">
              <Col
                xl={3}
                lg={12}
                xs={12}
                md={12}
                style={{
                  marginTop: "25px",
                }}
              >
                <img
                  height="120"
                  width="120"
                  className="border-rounded pointer-cursor"
                  src={this.props.userDetails?.image?.original}
                  style={{ objectFit: "cover" }}
                />
              </Col>
            </Row>
          </Row>
        </Col>

        <Col span={24} style={{ marginTop: "25px" }}>
          <Row justify="space-between" gutter={[20, 0]}>
            <Col xl={8} lg={24} xs={1} sm={12} md={12}>
              <WelcomeCard
                cardImg={AccountImg}
                cardHash={"#1"}
                cardHeading={"ACCOUNT SET-UP"}
                cardText={
                  "    For Demo Purposes the account setups are prepopulated. This includes all information under the Profile, Business, andAccount tabs along with the payment method"
                }
                cardStep={"Go to step 2 >>"}
              />
            </Col>
            <Col xl={8} lg={24} xs={1} sm={12} md={12}>
              <WelcomeCard
                cardImg={UserIcon}
                cardHash={"#2"}
                cardHeading={"ADD EMPLOYEES"}
                cardText={
                  "    Add employees for admin puproposes. Include people that will have access to the logistics process and reporting."
                }
              />
            </Col>
            <Col
              xl={8}
              lg={24}
              xs={1}
              sm={12}
              md={12}
              style={{ marginBottom: "5px" }}
            >
              <WelcomeCard
                cardImg={DriverIcon}
                cardHash={"#3"}
                cardHeading={"ADD DRIVERS"}
                cardText={
                  "Add drivers and be sure to use a phone number that is real so you can test the TRKR Mobile APP."
                }
                cardText2={
                  "Once you have identified your drivers, provide the drivers email and phone number to Main Frame. We will send an email wit a link, the driver needs to open the link on his phone in order to download the DEMO ONLY app."
                }
              />
            </Col>
            <Col
              xl={16}
              lg={24}
              xs={1}
              sm={12}
              md={12}
              style={{ marginTop: "20px" }}
            >
              <WelcomeCard
                className="text-left"
                cardImg={TruckIcon}
                cardHash={"#4"}
                cardHeading={"DOWNLOAD THE TRKR MOBILE APP (for Demo)"}
                cardText={
                  "Download the Demo Version of the TRKR MOBILE APP For the DEMO 1. Download the DEMO-ONLY TRKR Mobile App 2. Password The mobile app allows you to add pictures, videos, notes, voice notes so tat there are records of everything for each stage of the delivery process."
                }
                isShowTruck={true}
              />
            </Col>
            <Col
              xl={8}
              lg={24}
              xs={1}
              sm={12}
              md={12}
              style={{ marginTop: "20px" }}
            >
              <WelcomeCard
                cardImg={LineIcon}
                cardHash={"#5"}
                cardHeading={"DASHBOARD"}
                cardText={" Everything at your fingertips. Review orders:"}
                isShowDashboardItem={true}
              ></WelcomeCard>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    userDetails: store.UserReducer.userDetails,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserDetail: (userId) => dispatch(UserAction.getUserDetailReq(userId)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(WelcomeContainer);
